import { configureStore } from "@reduxjs/toolkit";
import CustomizerReducer from "./customizer/CustomizerSlice";
import UserReducer from "./data/user/reducerUser";

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    // new
    userReducer: UserReducer,
  },
});

export default store;
